import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { CommonAppModule } from '../../common/common-app.module';
import { PipeModule } from '../../common/pipes/pipe.module';
import { SvgCommonModule } from '../../shared/svg/svg-common.module';
import { UiModule } from '../../ui/ui.module';

import { PromotionActivationComponent } from './components/promotion-activation/promotion-activation.component';
import { PromotionCardComponent } from './components/promotion-card/promotion-card.component';
import { PromotionDetailComponent } from './components/promotion-detail/promotion-detail.component';
import { PromotionRatesComponent } from './components/promotion-rates/promotion-rates.component';
import { PromotionsFiltersComponent } from './components/promotions-filters/promotions-filters.component';
import { PromotionsComponent } from './promotions.component';


const standaloneComponents = [PromotionRatesComponent]
@NgModule({
	imports: [
		CommonModule,
		CommonAppModule,
		UiModule,
		PipeModule,
		FormsModule,
		RouterModule,
		SvgCommonModule,

		...standaloneComponents,
	],
	declarations: [
		PromotionsComponent,
		PromotionsFiltersComponent,
		PromotionCardComponent,
		PromotionActivationComponent,
		PromotionDetailComponent,
	],
})

export class PromotionsModule { }
